"use client";

import { Linkedin, Mail, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Leadership() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const engineers = [{
    name: "Americo Moscariello",
    title: "FOUNDER & PRINCIPAL",
    bio: "With over three decades of experience, Americo oversees every project with a commitment to structural integrity and timeless design.",
    years: "YEARS AT MOSCARIELLO:48",
    image: "https://inviting-mouse.10web.cloud/wp-content/uploads/2026/07/Image-2026-07-02-at-11.03.18-AM.jpeg?v=krxct37nv4",
    srcset: "https://inviting-mouse.10web.cloud/wp-content/uploads/2026/07/Image-2026-07-02-at-11.03.18-AM.jpeg?v=hxshg9l57mo-wvc-srcset",
    sizes: "https://inviting-mouse.10web.cloud/wp-content/uploads/2026/07/Image-2026-07-02-at-11.03.18-AM.jpeg?v=7jfsx51g85g-wvc-sizes"
  }, {
    name: "MARYANN ZIGORIS",
    title: "PROJECT DIRECTOR",
    bio: "Specializing in high-end residential construction, Maryann ensures that every detail aligns with the client's vision and our quality standards.",
    years: "12",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/director_elena.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/director_elena.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/director_elena.png-wvc-sizes"
  }, {
    name: "Marcus Thorne",
    title: "SITE SUPERINTENDENT",
    bio: "Marcus manages the daily operations on-site, ensuring safety, efficiency, and precision in every phase of the build process.",
    years: "15",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/superintendent_marcus.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/superintendent_marcus.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/superintendent_marcus.png-wvc-sizes"
  }, {
    name: "Sarah Jenkins",
    title: "PROPERTY MANAGER",
    bio: "Sarah provides comprehensive stewardship for our managed properties, focusing on long-term value and seamless maintenance.",
    years: "08",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/manager_sarah.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/manager_sarah.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/manager_sarah.webp-wvc-sizes"
  }, {
    name: "David Chen",
    title: "ESTIMATOR & PLANNER",
    bio: "David brings technical accuracy to our pre-construction phase, ensuring transparent budgeting and realistic project timelines.",
    years: "10",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/estimator_david.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/estimator_david.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/estimator_david.png-wvc-sizes"
  }, {
    name: "Julian Vane",
    title: "ARCHITECTURAL LIAISON",
    bio: "Julian bridges the gap between design intent and field execution, ensuring that complex architectural details are built to last.",
    years: "07",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/liaison_julian.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/liaison_julian.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723461/img/liaison_julian.png-wvc-sizes"
  }];
  return <section data-section-id="2576" id="the-leadership-team" className="bg-background text-foreground py-24 md:py-32 lg:py-44 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono uppercase text-xs md:text-sm tracking-widest text-primary mb-6">
            THE LEADERSHIP TEAM 
          </p>
          <h2 className="font-default font-bold uppercase text-5xl sm:text-6xl md:text-7xl lg:text-[6rem] leading-[0.95] text-foreground tracking-tight">
            The foundation of our craft.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {engineers.map((engineer, i) => <div data-index={i} key={engineer.name} className="group relative bg-card backdrop-blur-xl border border-border p-8 shadow-md transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg hover:border-primary">
              <div className="relative aspect-square w-full overflow-hidden mb-6">
                
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/10 mix-blend-color transition-all duration-700" />
              </div>

              <Separator className="bg-border mb-6" />

              <div className="space-y-4">
                <h3 className="font-default font-bold uppercase text-2xl text-foreground leading-tight">
                  {engineer.name}
                </h3>
                <p className="font-mono uppercase text-[12px] tracking-widest text-primary">
                  {engineer.title}
                </p>
                <p className="font-default text-base leading-relaxed text-muted-foreground line-clamp-3">
                  {engineer.bio}
                </p>
              </div>

              <div className="mt-8 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  
                  
                  <Button variant="ghost" size="icon" className="size-9 hover:bg-transparent text-foreground hover:text-primary transition-colors" aria-label={`Email ${engineer.name}`}>
                    <Mail className="size-[18px]" strokeWidth={1.5} />
                  </Button>
                </div>
                <span className="font-mono uppercase text-[11px] tracking-widest text-primary">
                  YEARS AT MOSCARIELLO: {engineer.years}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}